export default __webpack_public_path__ + "84fd3e437adace024e4096c73030b5b1.png";